import { Container } from '@chakra-ui/react';
import { NextSeo } from 'next-seo';
import { Fragment, useEffect } from 'react';

import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';

const Submit = () => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://paperform.co/__embed.min.js';
    document.body.appendChild(script);
  }, []);

  return (
    <Fragment>
      <NextSeo title="Submit Content" />
      <Layout navigationVariant="inverted">
        <Container bg="gray.50">
          <div data-paperform-id="underline-papersubmit" />
        </Container>
      </Layout>
    </Fragment>
  );
};

export default Submit;
